
const validate = (values: any) => {
  const errors: { [key: string]: boolean } = {};

  if (!values.name || values.name.trim() === '') {
    errors.name = true;
  }

  if (!values.default_language_locale) {
    errors.default_language_locale = true;
  }

  return errors;
};

export default validate;
